/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Schedule_Conflicts_RunInputs */

const vi_error_irrigation_schedule_conflicts_run = /** @type {(inputs: Error_Irrigation_Schedule_Conflicts_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch mới trùng một phiên hẹn giờ đã đặt. Huỷ phiên đó trong danh sách phiên tưới hoặc đổi giờ lịch.`)
};

/**

* @param {Error_Irrigation_Schedule_Conflicts_RunInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_schedule_conflicts_run = /** @type {((inputs?: Error_Irrigation_Schedule_Conflicts_RunInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Schedule_Conflicts_RunInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_schedule_conflicts_run(inputs)
});